import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { FeedbackContext } from '@cvt/contexts';
import { request } from '@cvt/clients/baseClient';

const apiBaseUrl = import.meta.env.VITE__CVT_API_URL as string;

export interface CheckoutSessionPayload {
    quantity: number;
    price_id: string;
    tribute_id?: string;
    credit_id?: string;
    promotion_code?: string;
}

export const useCheckoutSession = () => {
  const { genericErrorFeedback } = useContext(FeedbackContext);

  const createSession = useMutation({
    mutationKey: ['createCheckoutSession'],
    mutationFn: async (payload: CheckoutSessionPayload) => {
      const options = {
        url: `${apiBaseUrl}/update-my-checkout/`,
        method: 'POST',
        data: payload,
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const response = await request({ options, authenticate: true });
      return response.data;
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  interface PromotionCodeValidationPayload {
    promotion_code: string;
  }

  const validatePromoCode = useMutation({
    mutationKey: ['validatePromoCode'],
    mutationFn: async (payload: PromotionCodeValidationPayload) => {
      const options = {
        url: `${apiBaseUrl}/validate-checkout-promotion-code/`,
        method: 'POST',
        data: payload,
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const response = await request({ options, authenticate: true });
      return response.data;
    },
  });

  return {
    createSession,
    validatePromoCode,
  };
};
